import {IAnyObject} from "./SimpleInterface";
import {requireDate} from "./SiteHelper";

export type FileType = "file" | "image";

export default class FileVO
{
    fileType: FileType = "file";
    values:IAnyObject = {};

    id:number = 0;
    filename: string = "";
    title:string = "";
    url:string = "";
    subType:string = "";
    mimeType:string = "";
    icon:string = "";
    alt:string = "";
    caption:string = "";
    description:string = "";
    fileSize:number = 0;
    valid:boolean = false;
    date:Date|null = null;
    friendlySize:string = "";
    extension:string = "";

    constructor(object: IAnyObject|null = null, isExtended: boolean = false)
    {
        if(!isExtended){
            this.populate(object ?? {});
        }
    }

    populate(object: IAnyObject){
        this.values = object;
        this.id = object.id && !isNaN( object.id) ? parseInt(object.id) : 0;
        this.title = object.title ?? "";
        this.title = this.title ? this.title : (object.name ?? "");
        this.filename = object.filename ?? "";
        this.filename = this.filename ? this.filename: this.title;
        this.subType = object.subtype ?? "";
        this.mimeType = object.mime_type ?? "";
        this.url = object.url ?? "";
        this.icon = object.icon ?? "";
        this.alt = object.alt ?? "";
        this.caption = object.caption ?? "";
        this.description = object.description ?? "";
        this.fileSize = object.filesize && !isNaN( object.filesize) ? parseInt(object.filesize) : 0;
        this.valid = !!this.id && !!this.filename && !!this.url;
        this.date = requireDate(object.date ?? null);
        this.friendlySize = object.friendlysize ?? "";
        this.extension = object.extension ?? "";
    }
}